import React from 'react'

export default function ButtonArrow({ className, fill }) {
    return (
        <>
            <svg className={className} xmlns="http://www.w3.org/2000/svg" width="18.412" height="18.368" viewBox="0 0 18.412 18.368">
                <path id="Path_56" data-name="Path 56" d="M0,16.953,14.954,2H8.078V0H18.412V10.335h-2V3.37l-15,15Z" fill={fill} />
            </svg>
        </>
    )
}